import { useCustomerTypeLoaders } from "../loaders/customerTypeLoaders"
import { useCustomerTypeActions } from "../actions/customerTypeActions"
import { useCustomerTypeBuilders } from "../builders/customerTypeBuilders"

export const useCustomerTypeService = () => {
    const { buildCustomerType } = useCustomerTypeBuilders()

    const customerTypeLoaders = useCustomerTypeLoaders()

    const { saveCustomerType, saveCustomerTypes } = useCustomerTypeActions()

    const archiveCustomerType = async (customerTypeId: string) => {
        const { loadCustomerType } = customerTypeLoaders()
        const customerType = await loadCustomerType(customerTypeId, true)
        const archivedCustomerType = buildCustomerType({
            ...customerType,
            archived: true
        })
        return saveCustomerType(archivedCustomerType)
    }

    // Quita el producto de los rendimientos/exclusiones de todos los tipos de cliente que lo referencian
    const removeProductFromCustomerTypes = async (productId: string) => {
        const { loadCustomerTypesWithProp } = customerTypeLoaders()
        const customerTypes = await loadCustomerTypesWithProp('productYields', true)
        const updatedCustomerTypes = customerTypes
            .filter(customerType => customerType.productYields?.some(productYield => productYield.productId === productId))
            .map(customerType => buildCustomerType({
                ...customerType,
                productYields: customerType.productYields.filter(productYield => productYield.productId !== productId)
            }))
        if (updatedCustomerTypes.length > 0) {
            await saveCustomerTypes(updatedCustomerTypes)
        }
    }

    return {
        archiveCustomerType,
        removeProductFromCustomerTypes
    }
}
